"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeMessage = void 0;
const MessagesMapper_1 = require("./MessagesMapper");
const Message_1 = __importDefault(require("../message/Message"));
const makeMessage = (messageResponseData, userDirectory, organizationUser, httpAdapter, socketAdapter) => {
    const message = (0, MessagesMapper_1.messageMapper)(messageResponseData, userDirectory, organizationUser.getOrganization());
    return message
        ? new Message_1.default(message, socketAdapter, httpAdapter, userDirectory, organizationUser)
        : undefined;
};
exports.makeMessage = makeMessage;
